import React, { Component }  from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import Layout from "./Layout/Layout";
import ErrosEstrutura from './Componente/Resultado/ErrosEstrutura';
import Resultado from './Componente/Resultado/Resultado';
import HistoricoResultado from './Componente/HistoricoResultado/HistoricoResultado';
import EnviarArquivos from './Componente/Arquivos/EnviarArquivos';
import Ajuda from './Componente/Ajuda/Ajuda';
import Feedback from './Componente/Feedback/Feedback';
import ArquivosRecentes from './Componente/Arquivos/ArquivosRecentes';
import ParametrosAuditoria from './Componente/ParametrosAuditoria/ParametrosAuditoria';
import SimularAcesso from './Componente/SimularAcesso/SimularAcesso';
import ValidarLogin from './Componente/ValidarLogin/ValidarLogin';
import Erros from './Componente/Common/Erros';
import WhitePage from './Layout/WhitePage';
import ModalToken from './Componente/ValidarLoginToken/ModalToken';
import Cookies from 'js-cookie'



class Routes extends Component{
	constructor(props) {
		super(props);





}

	validarCookie = () => {
		let enviroment = "";
		let cookie = Cookies.get('bG9naW4');

		if (window.location.href.indexOf("localhost") >= 0) {
			enviroment = "dev";
		}
		else if (window.location.href.indexOf("ec2-34-206-89-100.compute-1.amazonaws.com:9090") >= 0) {
			enviroment = "homolog";
		}
		else {
			enviroment = "prod";
		}

		if (enviroment == "prod") {
			if (cookie != undefined && cookie != "") {
				cookie = atob(cookie);
				cookie = JSON.parse(cookie);

				var splits = cookie.data_login.split('-');

				var data = parseInt(splits[0] + splits[1] + splits[2]);
				var dataComparar = new Date();
				var auxAno = dataComparar.getFullYear().toString();
				var auxMes = ('0' + (parseInt(new Date().getMonth()) + 1).toString()).slice(-2);
				var auxDia = ('0' + new Date().getDate()).slice(-2);

				var aux = parseInt(auxAno + auxMes + auxDia);

				// console.log(data.toString() + '.' + aux.toString());

				if (data < aux) {
					return false;
				} else {
					return true;
				}
			}
			else {
				return false;
			}
		}
		else {
			return true;
		}
	}


	render(){

		return(
			<BrowserRouter>
				<Switch>
					{/* <Route exact path="/">
						<Layout params="">
							<ArquivosRecentes/>
						</Layout>
					</Route> */}
					<Route exact path="/resultadoErros/:idArquivo/:moduloEfd/:origem" render={({ match }) => (
						<Layout params={match.params}>
							{
								this.validarCookie() ? <ErrosEstrutura params={match.params} /> : window.location.href = 'https://www.econeteditora.com.br/user/ver_log.asp?Pag=http://www.econeteditora.com.br'
							}
						</Layout>
						)}>
					</Route>
					<Route exact path="/resultado/:idArquivo/:moduloEfd/:tpValidacao/:bloquearFiltrosInativos/:origem" render={({ match }) => (
						<Layout params={match.params}>
							{
								this.validarCookie() ? <Resultado params={match.params} /> : window.location.href = 'https://www.econeteditora.com.br/user/ver_log.asp?Pag=http://www.econeteditora.com.br'
							}
						</Layout>
					)}>
					</Route>
					<Route exact path="/historicoResultado">
						<Layout params="">
							{
								this.validarCookie() ? <HistoricoResultado/> : window.location.href = 'https://www.econeteditora.com.br/user/ver_log.asp?Pag=http://www.econeteditora.com.br'
							}
						</Layout>
					</Route>
					<Route exact path="/ajuda">
						<Layout params="">
							<Ajuda modal="1"/>
						</Layout>
					</Route>
					<Route exact path="/arquivos-recentes">
						<Layout params="">
							{
								this.validarCookie() ? <ArquivosRecentes/> : window.location.href = 'https://www.econeteditora.com.br/user/ver_log.asp?Pag=http://www.econeteditora.com.br'
							}
						</Layout>
					</Route>
					<Route exact path="/parametros-auditoria">
						<Layout params="">
							{
								this.validarCookie() ? <ParametrosAuditoria/> : window.location.href = 'https://www.econeteditora.com.br/user/ver_log.asp?Pag=http://www.econeteditora.com.br'
							}
						</Layout>
					</Route>
					<Route exact path="/simular-acesso">
						<Layout params="">
							<SimularAcesso/>
						</Layout>
					</Route>
					<Route exact path="/validar-login/:idUsuario?" render={({ match }) => (
						<ValidarLogin params={match.params} />
					)}>
					</Route>
					<Route exact path="/validar-token" render={({ match }) => (
						<WhitePage>
							<ModalToken modal={true} />
						</WhitePage>
					)}>
					</Route>
					<Route exact path="/feedback">
						<Layout params="">
							<Feedback/>
						</Layout>
					</Route>
					<Route exact path="/Erro">
						<WhitePage>
							<Erros/>
						</WhitePage>
					</Route>
					<Route path="*" >
						<WhitePage>
							<Erros/>
						</WhitePage>
					</Route>
				</Switch>
			</BrowserRouter>
		)
	}
}

export default Routes;


// WEBPACK FOOTER //
// ./src/Router.js